export const DEFAULT_LOCATION = {
  provinceIsocode: 'dki_jakarta',
  provinceName: 'DKI Jakarta',
  citySlug: 'jakarta-pusat',
  cityName: 'Jakarta Pusat',
  cityIsocode: '0080',
};
